import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyC3JSwBxKmDUhQdUc8L0wgLe3QuIWd1gxQ",
  authDomain: "zomato-login-743bc.firebaseapp.com",
  projectId: "zomato-login-743bc",
  storageBucket: "zomato-login-743bc.appspot.com",
  messagingSenderId: "571137547667",
  appId: "1:571137547667:web:46923f54f13bea59ad1c66",
  measurementId: "G-VRGX5DM8HE",
};
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth();
